<template>
  <div>
    <!-- 外層按鈕：打開簽名板 -->
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <div style="vertical-align: middle;float: left;font-size: 14px;color: #606266;line-height: 40px;padding: 0 12px 0 0;">簽名確認 </div>
      <el-button v-if="canSign" @click="dialogVisible = true" type="primary" round>打開簽名板</el-button>
    </div>

    <!-- 簽名預覽：保持在外層 -->
    <div style="margin-top: 20px;">
      <img v-if="displaySignature" :src="displaySignature" alt="簽名圖片" class="signature-preview" />
      <div v-else class="signature-preview no-signature">尚未簽名</div>
    </div>
    <!-- el-dialog 內放簽名板 -->
    <el-dialog v-if="canSign" title="請簽名" :visible.sync="dialogVisible" width="650px" :modal="false" :modal-append-to-body="false" :show-close="false" center :top="`18px`">
      <!-- 外層容器：固定寬度 + flex 置中 -->
      <div class="signature-container">
        <div class="signature-wrapper">
          <vue-signature ref="signature" :w="'450px'" :h="'300px'" :backgroundColor="'#fff'" :penColor="'#000'" />
        </div>
      </div>
      <div class="signature-actions" slot="footer">
        <el-button @click="onClear" round style="width:100%">清除</el-button>
        <el-button @click="onSave" round type="primary" style="width:100%">儲存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vueSignature from 'vue-signature'

export default {
  name: 'SignaturePadDialog',
  components: { vueSignature },
  props: {
    mode: {
      type: String,
      default: 'edit', // 'edit' 編輯模式 , 'view' 檢視模式
    },
    signaturePath: {
      type: String,
      default: null,
    },
    supplementMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      signatureData: null,
      emptySignature: null, // 存一份空白簽名的 base64
    }
  },
  computed: {
    displaySignature() {
      return this.signaturePath || this.signatureData
    },
    canSign() {
      if (this.supplementMode) {
        return !this.displaySignature
      }
      return this.mode === 'edit'
    },
  },
  methods: {
    onClear() {
      this.$refs.signature.clear()
      this.signatureData = null // 清除時外層顯示「尚未簽名」
      this.dialogVisible = false
    },
    onSave() {
      // 取得 base64
      this.signatureData = this.$refs.signature.save()
      this.dialogVisible = false

      // 轉格式
      const blob = this.base64ToBlob(this.signatureData)
      const rid = Math.floor(Math.random() * 5000000)
      const file = new File([blob], `signature_${rid}.png`, { type: blob.type })

      const formData = new FormData()
      formData.append('files[]', file)
      formData.append('dir', 'signature')

      // emit 給父層
      this.$emit('signatureSaved', formData)
    },

    base64ToBlob(base64) {
      const arr = base64.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog--center .el-dialog__body {
  padding: 0px;
}

.signature-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.signature-wrapper {
  border: solid 3px #ea6a2a;
  border-radius: 8px;
  background-color: #ffffff;
  font-size: 18px;
  display: inline-block; /* 讓邊框緊貼內容 */
}

.signature-actions {
  margin-top: 12px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.signature-preview {
  width: 100%;
  height: 180px;
  object-fit: contain;
  border: solid 2px #e5e7eb;
  border-radius: 8px;
}

.no-signature {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
  font-size: 18px;
  color: #999;
}
</style>
